import script from "./WhatWeBelieve.vue?vue&type=script&setup=true&lang=js"
export * from "./WhatWeBelieve.vue?vue&type=script&setup=true&lang=js"

import "./WhatWeBelieve.vue?vue&type=style&index=0&id=324f0f9a&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324f0f9a"]])

export default __exports__